module.exports = __webpack_public_path__ + "img/anasayfa-urun-bg-alt.961218c3.png";